import { render, staticRenderFns } from "./DocsWEncoded.vue?vue&type=template&id=60ee3824"
import script from "./DocsWEncoded.vue?vue&type=script&lang=js"
export * from "./DocsWEncoded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports